<template>
	<div class="full">
		<div class="load1">
			<div class="load1_img6_img"><img src="../img/load1_img6_img.jpg" /></div>
			<div class="load1_img5_img point" style="-webkit-animation-delay: .4s;"></div>
			<div class="load1_img4_img point" style="-webkit-animation-delay: .2s;"></div>
			<div class="load1_img3_img point"></div>
			
			<div class="load1_img2_img" v-show="rabbit==0"><img src="../img/load1_img2_img.png" /></div>
			<div class="load1_img1_img" v-show="rabbit==1"><img src="../img/load1_img1_img.png" /></div>
			
			<div class="load1_img7_img">
				<div class="full">
					<div class="full pro" :style="{left:(percent-100)+'%'}"></div>
					<div class="load1_img8_img animated fadeIn" style="-webkit-animation-duration: .2s;" v-show="iconShow" :style="{left:(percent-6)+'%'}"><img style="height: 100%;width: auto;" src="../img/load1_img8_img.png" /></div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<style scoped>
.load1_img6_img{position:absolute;left:0.00%;top:0.00%;width:100.00%;height:100.00%;}
.load1_img7_img{position:absolute;left:16.53%;top:52.98%;width:67.34%;height:2.16%;border-radius: 1000px;overflow: hidden;}
.load1_img5_img{position:absolute;left:67.33%;top:58.20%;width:1.07%;height:0.50%;}
.load1_img4_img{position:absolute;left:65.07%;top:58.20%;width:1.06%;height:0.50%;}
.load1_img3_img{position:absolute;left:62.80%;top:58.20%;width:1.07%;height:0.50%;}
.load1_img2_img{position:absolute;left:23.73%;top:33.35%;width:39.34%;height:16.59%;}
.load1_img1_img{position:absolute;left:25.07%;top:32.02%;width:45.06%;height:17.85%;}
.load1{position:absolute;left:0.00%;top:0.00%;width:100%;height:100%;}
.pro{
	background-color: white;
	border-radius: 1000px;
	overflow: hidden;
	left: 0;
	top: 0;
}
.load1_img8_img{
	position: absolute;
	width: auto;
	height: 100%;
}
.point{
	top:58.60%;
	background-color: #f2d3a7;
	border-radius: 1000px;
	overflow: hidden;
}
	.point {
		-webkit-animation: point 1s linear infinite;
	}
	@-webkit-keyframes point {
		0% {
			-webkit-transform: translate(0,0);
		}
		20% {
			-webkit-transform: translate(0,10px);
		}
		30% {
			-webkit-transform: translate(0,0);
		}		
	}
</style>
<script>
	//import imageData from '../imgData.json'
	export default {
		data() {
			return {
				percent: 0,
				iconShow:false,
				rabbit:1
			};
		},
		computed: {

		},
		mounted() {
			// let data = imageData.resources
			// let count = data.length
			// let index = 0	
			// data.forEach((item) => {
			// 	let img = new Image()
			// 	img.src = require('../img/' + item.url)
			// 	img.onload = function() {
			// 		setTimeout(() => {
			// 			index++	
			// 			if (index >= count) {
			// 				this.$store.commit('setCurrentPage', {page: 'p1'})													
			// 			} else {
			// 				this.percent = Math.ceil(index / count * 100)
			// 			}
			// 		},Math.random()*500)
			// 	}.bind(this)
			// })	
			
			
			let index = 0
			let t = setInterval(() => {
				index++
				this.rabbit = parseInt(index%8/4)
				if (index > 100) {
					clearInterval(t)
					setTimeout(()=>{
						this.$store.commit('setCurrentPage', {page: 'p1'})
					},500)
				} else {
					this.percent = index
				}
			}, 30)
		},
		watch: {
			percent(val){
				this.iconShow = val>10
			}
		},
		methods: {

		},
		components: {

		}
	}
</script>
